module.exports = __webpack_public_path__ + "img/21.d46be01a.png";